<template>
  <b-row>
    <b-col md="9">
      <b-card
        id="invoicePrint"
        class="container-invoice-information"
      >
        <b-row>
          <b-col md="8">
            <img
              class="img-logo-print d-block"
              :src="require('@/assets/svg/maxlogo.png')"
              alt="Logo"
              style="width:150px;height:50px;"
            >
            <span
              class="text-address"
              v-html="getDetail.kop.company_address"
            />
            <span
              class="text-address"
            >
              {{ getDetail.kop.phone }}
            </span>
          </b-col>
          <b-col
            md="4"
          >
            <h4 class="invoice-no">
              Invoice {{ invoiceNo }}</h4>
            <span class="content-date">
              <span class="header-text w-5">Date Issued:</span>
              <span class="value-text text-right">{{ formatDateIdr(getDetail.invoice_detail.invoice_date) }}</span>
            </span>
            <span class="content-date">
              <span class="header-text w-5">Due Date:</span>
              <span class="value-text text-right">{{ formatDateIdr(getDetail.invoice_detail.due_date) }}</span>
            </span>
          </b-col>
        </b-row>
        <hr>
        <b-row class="mb-2">
          <b-col md="8">
            <h4 class="title-invoice">
              Invoice To:</h4>
            <h5 class="short-company-name">
              {{ toCapitalize(getDetail.invoice_to.firstname) }} {{ toCapitalize(getDetail.invoice_to.lastname) }}</h5>
            <!-- <h5 class="short-company-name">
              {{ getDetail.npwp_number }}</h5> -->
            <span class="container-address-company">
              <span class="company-name">{{ toCapitalize(getDetail.invoice_to.company_name) }}</span>
              <span class="text-address-company">NPWP: {{ (getDetail.invoice_to.npwp_number===null || getDetail.invoice_to.npwp_number==='') ? '-' : getDetail.invoice_to.npwp_number }} <br>{{ toCapitalize(getDetail.invoice_to.company_address) }} <br>{{ toCapitalize(getDetail.invoice_to.regencies) }}, {{ toCapitalize(getDetail.invoice_to.country) }} <br> {{ getDetail.invoice_to.phone }}</span>
            </span>
          </b-col>
          <b-col md="4">
            <h4 class="title-payment-detail">
              Payment Details:</h4>
            <h4 class="total-payment">
              Total Due: IDR {{ formatPrice(getDetail.payment_detail.total_due) }}</h4>
            <span class="container-bank-information">
              <span class="bank-detail">Bank name: {{ getDetail.payment_detail.bank_name }}</span>
              <span class="bank-detail">Account Name: {{ getDetail.payment_detail.bank_account_name }}</span>
              <span class="bank-detail">Account Number: {{ getDetail.payment_detail.bank_account }}</span>
              <!-- <span class="bank-detail">Description: #3492</span> -->
            </span>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="12">
            <table class="table-transaction">
              <thead>
                <tr>
                  <th>#</th>
                  <th v-if="getDetail.invoice_detail.invoice_type_id === 2">
                    Campaign ID</th>
                  <th v-if="getDetail.invoice_detail.invoice_type_id === 2">
                    Channel</th>
                  <th
                    v-if="getDetail.invoice_detail.invoice_type_id === 1"
                    class="col-7"
                  >
                    TOP UP Amount</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td v-if="getDetail.invoice_detail.invoice_type_id === 2">
                    {{ getDetail.invoice_detail.campaign_id }} </td>
                  <td v-if="getDetail.invoice_detail.invoice_type_id === 2">
                    <b>{{ getDetail.invoice_detail.channel_name }}</b><br>
                    <span class="text-muted">SMS Campaign Volume 10.000 CPA 2.000</span>
                  </td>
                  <td v-if="getDetail.invoice_detail.invoice_type_id === 1">
                    IDR {{ formatPrice(getDetail.invoice_detail.amount) }}</td>
                  <td>IDR {{ formatPrice(getDetail.invoice_detail.amount) }}</td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="8">
            <!-- <span class="container-note">
              <span class="header-note">Note:</span>
              <ul>
                <li>All payment should be made only by wire transfer</li>
                <li>Please send the receipt copy by mail to: finance@three.co.id</li>
              </ul>
              <span class="footer-note">Tax Invoice Number: 011.024-20.67531235</span>
            </span> -->
          </b-col>
          <b-col md="4">
            <span class="container-calculation">
              <span class="subtotal">
                <span class="title-calculation">Subtotal:</span>
                <span class="float-right ml-1 mr-1 value-calculation">IDR {{ formatPrice(getDetail.invoice_detail.amount) }}</span>
              </span>
              <!-- <span class="discount">
                <span class="title-calculation">Discount:</span>
                <span class="value-calculation">-</span>
              </span> -->
              <span class="tax">
                <span class="title-calculation">Tax:</span>
                <span class="float-right ml-1 mr-1 value-calculation">{{ percenTax() }}%</span>
              </span>
              <hr>
              <span class="total">
                <span class="title-calculation">Total:</span>
                <span class="float-right ml-1 mr-1 value-calculation">IDR {{ formatPrice(getDetail.invoice_detail.total) }}</span>
              </span>
            </span>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-col
      v-if="getDetail.invoice_detail.status === 2 || getDetail.invoice_detail.status === 3 || getDetail.invoice_detail.status === 4"
      md="3"
    >
      <b-card>
        <b-button
          v-if="getDetail.invoice_detail.status === 3"
          class="btn-invoice btn-download"
          :href="getDetail.download_url"
        >
          Download
        </b-button>
        <!-- v-if="invoiceDetail.invoice_detail.invoice_type === 'TOP UP Credit' || invoiceDetail.invoice_detail.status === 1" -->
        <!-- <b-button
          class="btn-invoice btn-download"
        >
          Download Proof Invoice
        </b-button> -->
        <!-- <b-button
          class="btn-invoice btn-print"
          @click="printDiv"
        >
          Print
        </b-button> -->
        <!-- invoiceDetail.status === 2 -->
        <b-button
          v-if="getDetail.invoice_detail.status === 2 || getDetail.invoice_detail.status === 3 || getDetail.invoice_detail.status === 4"
          class="btn-invoice btn-print"
          :href="getDetail.invoice_detail.payment_proof"
          target="_blank"
        >
          See Payment Proof
        </b-button>
        <b-button
          v-if="getDetail.invoice_detail.status === 2"
          class="btn-invoice btn-confirm-payment"
          @click="showAlert"
        >
          Confirm Payment Received
        </b-button>
        <b-button
          v-if="getDetail.invoice_detail.status === 2"
          class="btn-invoice btn-reject-payment"
          @click="confirmReject"
        >
          Reject Payment
        </b-button>
        <!-- invoiceDetail.status === 3 || invoiceDetail.status === 4 || invoiceDetail.status === 5 -->
        <b-button
          v-if="getDetail.invoice_detail.status === 3"
          class="btn-invoice"
          disabled
        >
          Payment Confirmed
        </b-button>
      </b-card>
    </b-col>
    <popup-reject ref="rejectPopup" />
  </b-row>
</template>
<script>

import {
  BCard,
  BRow,
  BCol,
  BButton,
} from 'bootstrap-vue'
import { mapGetters, mapActions } from 'vuex'
import PopupReject from '@/views/component/PopupRejectInvoice.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    PopupReject,
  },
  data() {
    return {
      confirmed: false,
      invoiceNo: '',
      detail: {},
      options: {
        name: '_blank',
        specs: [
          'fullscreen=no',
          'titlebar=yes',
          'scrollbars=yes',
        ],
        styles: [
          'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
          // 'https://unpkg.com/kidlat-css/css/kidlat.css',
          '@/assets/scss/style.scss',
        ],
        timeout: 1000, // default timeout before the print window appears
        autoClose: true, // if false, the window will not close after printing
        windowTitle: window.document.title, // override the window title
      },
    }
  },
  computed: {
    ...mapGetters('finance', {
      getDetail: 'getInvoice',
    }),
    ...mapGetters('auth', {
      userData: 'getUserData',
    }),
  },
  mounted() {
    this.setInvoiceNo()
    this.detail = JSON.parse(JSON.stringify(this.getDetail))
    // if (!this.getDetail) {
    this.detailInvoice(this.$route.params.id)
    this.dataReasonInvoice()
    // }
  },
  methods: {
    ...mapActions('finance', [
      'confirmPayment',
      'detailInvoice',
      'downloadInvoice',
    ]),
    ...mapActions('datas', [
      'dataReasonInvoice',
    ]),
    setInvoiceNo() {
      this.invoiceNo = this.$route.params.id
    },
    formatDateIdr(date) {
      let dd = date.replace(/-/g, '/')
      let d = new Date(dd)
      const dt = (`0${d.getDate()}`).slice(-2)
      const month = (`0${d.getMonth() + 1}`).slice(-2)
      const year = d.getFullYear()
      return `${dt}/${month}/${year}`
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    showAlert() {
      // Use sweetalert2
      this.$swal({
        html: `
          <b>Confirm this payment?</b>
          <br>
          <br>
          <button class="btn btn-outline-primary btn-cancel"><feather-icon
              icon="XCircleIcon"
              class="ml-50"
            />Cancel</button>
          <button class="btn btn-primary btn-confirm ml-1">Confirm</button>
        `,
        icon: 'warning',
        showConfirmButton: false,
        showCancelButton: false,
        onBeforeOpen: () => {
          const cancel = document.querySelector('.btn-cancel')
          const confirm = document.querySelector('.btn-confirm')
          cancel.addEventListener('click', () => {
            this.$swal.close()
          })
          confirm.addEventListener('click', () => {
            const sendData = {
              invoice_no: this.$route.params.id,
            }
            this.confirmPayment(sendData).then(() => {
              this.$router.push({ name: 'invoice' })
            })
            this.confirmed = true
            this.$swal.close()
          })
        },
      })
    },
    approveTopup() {
      // API this.approveTopup
    },
    async printDiv() {
      // Pass the element id here
      await this.$htmlToPaper('invoicePrint', this.options)
    },
    confirmReject() {
      // this.setStatus(3)
      this.$refs.rejectPopup.showModal()
    },
    toCapitalize(text) {
      return text.toUpperCase()
    },
    percenTax() {
      return ((this.getDetail.invoice_detail.total - this.getDetail.invoice_detail.amount) * 100) / this.getDetail.invoice_detail.amount
    },
    // printDiv() {
    //   const modal = document.getElementById('invoicePrint')
    //   const cloned = modal.cloneNode(true)
    //   let section = document.getElementById('print')

    //   if (!section) {
    //     section = document.createElement('div')
    //     section.id = 'print'
    //     document.body.appendChild(section)
    //   }

    //   section.innerHTML = ''
    //   section.appendChild(cloned)
    //   window.print()
    // },
  },
}
</script>
<style scoped>
*{
  font-family: 'Rubik';
}
.w-5{
  width: 120px;
  display: inline-block;
}
.img-logo-print {
  width: 120px;
  height: 50px;
  object-fit: contain;
  display: block;
}
.text-address {
  display: block;
  width: 268px;
  letter-spacing: 0.2px;
  line-height: 1.5;
  margin-top: 10px;
}
.content-date {
  display: block;
}
.header-text {
  margin-right: 60px;
}
.header-text-second {
  margin-right: 77px;
}
.invoice-no {
  margin-bottom: 10px;
  color: #4B6AAE;
  font-weight: bold;
}
hr {
  margin-top: 20px;
  margin-bottom: 20px;
}
.container-invoice-information {
  padding-top: 25px;
}
.title-invoice {
  color: #4B6AAE;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 24px;
}
.short-company-name {
  font-weight: bold;
  margin-bottom: 10px;
}
.container-address-company {
  display: block;
}
.company-name {
  display: block;
}
.text-address-company {
  width: 268px;
  display: block;
}
.title-payment-detail {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 24px;
}
.total-payment {
  color: #6EC5B9;
  font-weight: bold;
  font-size:1.1rem;
}
.container-bank-information, .bank-detail {
  display: block;
}
.container-bank-information {
  line-height: 21px;
}
.table-transaction {
  width: 100%;
  border: 1px solid #f0f0f0;
}
.table-transaction > thead {
  background-color: #F4F7FF;
  color: #000;
}
th, td {
  height: 64px;
  padding: 0px 10px;
}
ul {
  list-style-type: "- ";
  padding: 10px 7px;
}
.footer-note {
  font-weight: bold;
  margin-top: 90px;
  display: block;
}
.subtotal, .discount, .tax, .total {
  display: block;
}
.title-calculation {
  display: inline-block;
  width: 61px;
}
.value-calculation {
  margin-left: 100px;
  font-weight: bold;
  color: #000;
}
.btn-invoice {
  display: block;
  width: 100%;
  margin-bottom: 10px;
  padding: 14px;
  font-weight: bold;
}
.btn-download, .btn-print {
  background-color: transparent !important;
  color: #000 !important;
  letter-spacing: 0.8px;
}
.btn-confirm-payment {
  background-color: #6EC5B9 !important;
  border: none;
  letter-spacing: 0.8px;
}
.btn-reject-payment {
  background-color: #dd4f2b !important;
  border: none;
  letter-spacing: 0.8px;
}
</style>
